import { cards } from '@/mocks/home';

export default function CardsSection() {
  return (
    <section id="cards" className="py-10 md:py-14 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div className="flex items-center gap-3">
            <div className="w-1 h-6 bg-secondary-500 rounded-full"></div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-900">精选推荐</h2>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.slice(0, 6).map((card) => (
            <div
              key={card.id}
              className="group bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-200 overflow-hidden transition-all duration-200 cursor-pointer"
            >
              <div className="relative aspect-[16/10] bg-background-100 overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-primary-500/90 text-background-50 text-xs font-medium rounded-full">
                    {card.category}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2">
                  {card.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 mt-2 line-clamp-2 leading-relaxed">
                  {card.desc}
                </p>
              </div>
            </div>
          ))}

          <div className="sm:col-span-2 lg:col-span-3 bg-gradient-to-r from-primary-100/60 via-accent-100/40 to-primary-100/60 rounded-xl border border-primary-200/60 p-6 md:p-8 flex flex-col md:flex-row items-center gap-4 md:gap-6">
            <div className="flex-shrink-0 w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-primary-500 text-background-50">
              <i className="ri-movie-2-line text-2xl md:text-3xl"></i>
            </div>
            <div className="flex-1 text-center md:text-left">
              <h3 className="text-base md:text-lg font-bold text-foreground-900">{cards[6].title}</h3>
              <p className="text-sm text-foreground-500 mt-1.5">{cards[6].desc}</p>
            </div>
            <a
              href="#cards"
              onClick={(e) => e.preventDefault()}
              className="flex-shrink-0 inline-flex items-center gap-2 px-6 py-2.5 bg-primary-500 text-background-50 text-sm font-semibold rounded-full hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              立即查看
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}